import { render, staticRenderFns } from "./DetailInternalMemoPK.vue?vue&type=template&id=704d6649"
import script from "./DetailInternalMemoPK.vue?vue&type=script&lang=js"
export * from "./DetailInternalMemoPK.vue?vue&type=script&lang=js"
import style0 from "./DetailInternalMemoPK.vue?vue&type=style&index=0&id=704d6649&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports